import { InputLabel } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ColorCircleIcon } from 'src/icons';
import { CommonElementProps } from '../types';
import ElementUtils from '../utils';

export interface ColorPickerProps extends CommonElementProps<string> {
  options: string[];
  onChange?: (data: string | null) => void;
}
const ColorPicker = function ColorPicker(props: ColorPickerProps) {
  const {
    options, onChange, value,
    error, label,
  } = props;
  const [selected, setSelected] = useState<string | undefined>(undefined);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleChange = (color: string) => {
    if (onChange) {
      onChange(color);
    }
    setSelected(color);
  };

  return (
    <div className="flex flex-col relative justify-center items-start">
      {label && (
        <InputLabel className="font-bold mb-2" error={!!error}>
          {label}
        </InputLabel>
      )}
      <div className="flex gap-1">
        {options.map((color: string) => (
          <ColorCircleIcon
            color={color}
            onClick={handleChange}
            isSelected={selected === color}
          />
        ))}
      </div>
      {error && (
        <div className="absolute -bottom-5 text-error text-xs">
          {ElementUtils.renderError(error)}
        </div>
      )}
    </div>
  );
};

ColorPicker.defaultProps = {
  onChange: () => { },
};

ColorPicker.propTypes = {

};
export default ColorPicker;
